import React from 'react'
import AutofillButton from 'src/participantHistory/autofill/AutofillButton'
import useAutofillIntakeNoteComprehensive from './useAutofillIntakeNoteComprehensive'

type Props = Omit<React.ComponentProps<typeof AutofillButton>, 'onAutofill'> & {
  uid: string
}

export default function AutofillIntakeNoteComprehensiveButton({ uid, ...props }: Props) {
  const autofillIntakeNoteComprehensive = useAutofillIntakeNoteComprehensive(uid)

  return <AutofillButton onAutofill={autofillIntakeNoteComprehensive} {...props} />
}
